import sanitizeHtml from 'sanitize-html';

// Note allowlist — the canonical RD-2584 set shared by editor, BE write-sanitizer, email-service and PDFs.
// Any value containing url( or expression is rejected on the style properties.
const noStyleExploit = [/^(?!.*(?:url\(|expression)).+$/i];
const noteStyles: sanitizeHtml.IOptions['allowedStyles'] = {
  '*': {
    'text-align': [/^(left|center|right)$/],
    'margin-left': noStyleExploit,
    'padding-left': noStyleExploit,
  },
};

const NOTE_SANITIZE: sanitizeHtml.IOptions = {
  allowedTags: ['p', 'br', 'b', 'strong', 'i', 'em', 'u', 's', 'a', 'ul', 'ol', 'li', 'blockquote', 'code', 'hr'],
  allowedAttributes: { a: ['href'], p: ['style'], li: ['style'] },
  allowedStyles: noteStyles,
  allowedSchemes: ['http', 'https', 'mailto'],
  allowedSchemesAppliedToAttributes: ['href'],
  disallowedTagsMode: 'discard',
};

export const sanitizeNoteHtml = (html?: string): string => {
  if (!html) return '';
  try {
    return sanitizeHtml(html, NOTE_SANITIZE);
  } catch {
    return '';
  }
};

const decodeEntities = (s: string): string => {
  if (!s || typeof document === 'undefined') return s;
  const el = document.createElement('textarea');
  el.innerHTML = s;
  return el.value;
};

// Flatten note HTML to a single plaintext line — for tooltips / collapsed labels where HTML can't render.
export const noteToPlainText = (html?: string): string => {
  if (!html) return '';
  try {
    const spaced = html.replace(/<\/(p|div|li|blockquote)>/gi, ' ').replace(/<br\s*\/?>/gi, ' ');
    const stripped = sanitizeHtml(spaced, { allowedTags: [], allowedAttributes: {} });
    return decodeEntities(stripped)
      .replace(/\s+/g, ' ')
      .trim();
  } catch {
    return '';
  }
};
